import { render, staticRenderFns } from "./SimpleProduct.vue?vue&type=template&id=595221d2&scoped=true&"
import script from "./SimpleProduct.vue?vue&type=script&lang=ts&"
export * from "./SimpleProduct.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleProduct.vue?vue&type=style&index=0&id=595221d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595221d2",
  null
  
)

export default component.exports